export default class DocXML {
    WordDoc;
    WordBody;
    BaseDoc;
    NumShapes;

    constructor() {
        this.BaseDoc = document.implementation.createDocument(null, null, null);
        this.WordDoc = this.BaseDoc.createElement('w:wordDocument');
        this.BaseDoc.appendChild(this.WordDoc);
        this.WordDoc.setAttribute('xmlns:w', 'http://schemas.openxmlformats.org/wordprocessingml/2006/main');
        this.WordDoc.setAttribute('xmlns:v', 'urn:schemas-microsoft-com:vml');
        this.WordDoc.setAttribute('xmlns:r', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships');
        this.WordBody = this.BaseDoc.createElement('w:body');
        this.WordDoc.appendChild(this.WordBody);
        this.NumShapes = 1;
    }

    addText(text) {
        let p = this.BaseDoc.createElement('w:p');
        this.WordBody.appendChild(p);
        let r = this.BaseDoc.createElement('w:r');
        p.appendChild(r);
        let t = this.BaseDoc.createElement('w:t');
        r.appendChild(t);
        let textNode = this.BaseDoc.createTextNode(text);
        t.appendChild(textNode);
    }

    addPageBreak() {
        let p = this.BaseDoc.createElement('w:p');
        this.WordBody.appendChild(p);
        let r = this.BaseDoc.createElement('w:r');
        p.appendChild(r);
        let br = this.BaseDoc.createElement('w:br');
        br.setAttribute('w:type', 'page');
        r.appendChild(br);
    }

    addImage(width, height) {
        let lwidth = width;
        let lheight = height;
        if (width > 576) {
            lwidth = 576;
            lheight = (height / width * lwidth); 
        }
        let p = this.BaseDoc.createElement('w:p');
        this.WordBody.appendChild(p);
        let r = this.BaseDoc.createElement('w:r');
        p.appendChild(r);
        let pict = this.BaseDoc.createElement('w:pict');
        r.appendChild(pict);
        let shape = this.BaseDoc.createElement('v:shape');
        pict.appendChild(shape);
        shape.setAttribute('id', 'myShape' + this.NumShapes);
        shape.setAttribute('type', '#_x0000_t75');
        shape.setAttribute('style', 'width:' + lwidth + '; height:' + lheight + ';');
        let imgdata = this.BaseDoc.createElement('v:imagedata');
        shape.appendChild(imgdata);
        imgdata.setAttribute('r:id', 'rId' + this.NumShapes);
        this.NumShapes = this.NumShapes + 1;
    }

    getString() {
        let xmlText = new XMLSerializer().serializeToString(this.BaseDoc);
        xmlText = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + xmlText;
        return xmlText;
    }
}


// WEBPACK FOOTER //
// ./src/javascript-classes/JS-DOCX/DocXML.js